<template>
  <div class="card card-custom gutter-b card-stretch">
    <!--begin::Body-->
    <div class="card-body pt-4 d-flex flex-column justify-content-between">
      <!--begin::User-->
      <div class="d-flex justify-content-between align-items-center mb-7">
        <!--begin::Title-->

        <p class="text-dark font-weight-bold font-size-h4 mb-0">
          {{ user.name }}
        </p>
        <p class="text-dark mb-0">
          <b-badge class="mr-1" :variant="user.status == 'ACTIVE' ? 'success' : 'danger'">{{ user.status }}</b-badge>
        </p>
        <!--end::Title-->
      </div>
      <!--end::User-->
      <!--begin::Info-->
      <div class="mb-7">
        <div class="d-flex justify-content-between align-items-center">
          <span class="text-dark-75 font-weight-bolder mr-2">Email:</span>
          <span class="text-muted font-weight-bold">{{ user.username }}</span>
        </div>
        <div class="d-flex justify-content-between align-items-cente my-1">
          <span class="text-dark-75 font-weight-bolder mr-2">Roles:</span>
          <span class="text-muted font-weight-bold">{{ user.roles }}</span>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between flex-wrap py-3">
        <div class="d-flex align-items-center mr-2 py-2">
          <router-link
            :to="{
              name: 'UpdateUser',
              params: { id: user.id, userObject: user }
            }"
            class="btn btn-icon btn-primary mx-3"
          >
            <i class="flaticon2-pen"></i>
          </router-link>
          <div class="btn btn-icon btn-primary mx-3">
            <i class="la la-user-lock"></i>
          </div>
        </div>

        <div
          class="btn btn-icon mx-3"
          :class="user.status == 'ACTIVE' ? 'btn-danger' : 'btn-warning'"
          @click="$emit('delete-user', user.id, user.status)"
        >
          <i class="la" :class="user.status == 'ACTIVE' ? 'la-lock' : 'la-lock-open'"></i>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
export default {
  name: "clientUserCard",

  props: ["user"]
};
</script>
